import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HelpModule } from '../../Help-Tooltip/help.module';
import { AceButtonModule } from '../Button/button.module';
import { AceCardComponent } from './card.component';

@NgModule({
    imports: [
        CommonModule,
        HelpModule,
        AceButtonModule
    ],
    declarations: [AceCardComponent],
    exports: [AceCardComponent]
})
export class AceCardModule { }
